import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTranslation, getLink, getSetting } from '../service/asset-json';
import { ConnectedLoginForm } from '../login-form/login-form.component';
import {
  Container,
  Wrapper,
  Logo,
  SignUp,
  BusinessAccount,
  NeedHelpMessage
} from './login.component.styles';
import gogoxLogo from '../assets/gogox-logo.svg';
import UpdateUserInfoModule from '../components/Login/UpdateUserInfoModule';
import Layout from '../components/Layout/Layout';

const Login = ({ currentLocale }) => {
  const SignUpLink = (
    <div>
      <SignUp>
        {getTranslation('no_account', currentLocale)}
        <a href={getLink('sign_up', currentLocale)}>
          {` ${getTranslation('sign_up', currentLocale)}`}
        </a>
      </SignUp>
      {currentLocale === 'en-IN' &&
        <NeedHelpMessage>
          {getTranslation('need_help_call_us', currentLocale, 'general')}
          <a href="tel:917550046469">{getTranslation('need_help_number', currentLocale, 'general')}</a>
        </NeedHelpMessage>
      }
    </div>
  );

  const BusinessLink = (
    <BusinessAccount>
      {getTranslation('business_account', currentLocale)}
      <a href={getLink('gogobusiness', currentLocale) }>
        {` ${getTranslation('click_here', currentLocale)}`}
      </a>
    </BusinessAccount>
  );

  const hasGogobusiness = getSetting('gogobusiness', currentLocale);

  return (
    <Layout showHeader={false} showFooter={false}>
      <Container>
        <Wrapper>
          <Logo src={gogoxLogo} alt="GOGOX" />
          <ConnectedLoginForm />
          {SignUpLink}
          {hasGogobusiness && BusinessLink}
        </Wrapper>
        <UpdateUserInfoModule />
      </Container>
    </Layout>
  );
};

Login.propTypes = {
  currentLocale: PropTypes.string.isRequired,
};

const mapState = state => ({
  currentLocale: state.intl.locale,
});

const ConnectedLogin = connect(mapState)(Login);

export { ConnectedLogin };



// WEBPACK FOOTER //
// ./src/login/login.component.js